/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/date': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#5E5E5E" fill-rule="evenodd" d="M15 2h-3V0h-2v2H6V0H4v2H1a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zM2 14h12V4h-2v2h-2V4H6v2H4V4H2v10z" clip-rule="evenodd"/>'
  }
})
